const ENVIRONMENT = {
    BACKEND_BASE_URL: process.env.NODE_ENV === 'production' ? 'https://api-pi-dot-api-rest-pi.rj.r.appspot.com' : 'http://localhost:3010',
    URL_SOCKET: process.env.NODE_ENV === 'production' ? 'https://api-pi-dot-api-rest-pi.rj.r.appspot.com' : 'localhost:3010',
    DELIVERY_RATIO: 5500
    //BACKEND_BASE_URL: 'http://localhost:3010'
}
export default ENVIRONMENT
